import _ from 'lodash'

export const hasContactInfo = user => {
  return !!_.trim(user.contact_info)
}

export const hasAnyRole = (user, roles) => {
  return user && _.intersection(user.roles, roles).length > 0
}
